export function fiscalCapabilities(permissions: readonly string[]) {
  return {
    canReview: permissions.includes("fiscal.read"),
    canIssue: permissions.includes("fiscal.issue"),
    canDownload: permissions.includes("fiscal.download"),
  };
}
